import Vue from 'vue';
import VueRouter from 'vue-router';
import { _isMobile } from '@/utils/config';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    // name: 'Home',
    component: () => import('@/pages'),
    children: [
      { path: '/', name: 'Home', component: () => import('@/pages/home') },
      { path: '/saas', name: 'SAAS', component: () => import('@/pages/saas') },
      { path: '/about', name: 'About', component: () => import('@/pages/about') },
      { path: '/smart', name: 'SMART', component: () => import('@/pages/smart') },
    ],
  },
  {
    path: '/help',
    name: 'Help',
    redirect: '/help/50/document',
    component: () => import('@/pages/help'),
    children: [
      {
        path: '/help/:type?/document/:id?',
        name: 'Document',
        component: () => (_isMobile() ? import('@/pages/help/document/mobile') : import('@/pages/help/document')),
      },
    ],
  },
  { path: '/login', name: 'Login', component: () => import('@/pages/login') },
  { path: '/register', name: 'Register', component: () => import('@/pages/register') },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
